import React, { JSX } from 'react'
import { Box } from '@moonpig/launchpad-components'
import { AllSystemProps as StyleProps } from '@moonpig/launchpad-system'

type Props = StyleProps & {
  htmlString: string
  as?: keyof JSX.IntrinsicElements
}

export const Markup: React.FC<Props> = ({ htmlString, as, ...styleProps }) => (
  // eslint-disable-next-line react/no-danger
  <Box
    dangerouslySetInnerHTML={{ __html: htmlString }}
    as={as}
    {...styleProps}
  />
)
